import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-lg font-semibold text-white mb-3">{title}</h2>
    <div className="text-gray-400 text-sm leading-relaxed space-y-2">{children}</div>
  </div>
)

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-gray-300">
      <div className="max-w-3xl mx-auto px-6 py-12">

        {/* Back */}
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-300 transition-colors mb-8">
          <ArrowLeft size={16} />
          Torna al login
        </Link>

        {/* Header */}
        <div className="mb-10">
          <h1 className="text-2xl font-bold text-white mb-2">Privacy Policy</h1>
          <p className="text-gray-500 text-sm">Ultimo aggiornamento: settembre 2026</p>
        </div>

        <Section title="1. Titolare del trattamento">
          <p>
            Il Titolare del trattamento dei dati personali è <strong className="text-gray-300">Matteo Congedo</strong>,
            libero professionista con P.IVA <strong className="text-gray-300">05352990757</strong>, operante sotto il
            nome commerciale <strong className="text-gray-300">Plutonic Studio</strong>.
          </p>
          <p>
            Per qualsiasi richiesta relativa al trattamento dei tuoi dati puoi contattarci
            all'indirizzo email: <a href="mailto:plutonicstudio.vfx@gmail.com" className="text-violet-400 hover:text-violet-300">plutonicstudio.vfx@gmail.com</a>
          </p>
        </Section>

        <Section title="2. Dati raccolti">
          <p>Nell'ambito dell'utilizzo della piattaforma Plutonic Studio raccogliamo le seguenti categorie di dati:</p>
          <ul className="list-disc list-inside space-y-1 mt-2 ml-2">
            <li><strong className="text-gray-300">Dati di registrazione:</strong> nome, cognome, nickname, indirizzo email, immagine del profilo</li>
            <li><strong className="text-gray-300">Dati di utilizzo:</strong> progetti, task, file caricati, comunicazioni via chat interna, note, eventi del calendario</li>
            <li><strong className="text-gray-300">Dati tecnici:</strong> indirizzo IP, tipo di browser, dati di sessione necessari al funzionamento del servizio</li>
            <li><strong className="text-gray-300">Richieste dal sito:</strong> nome, cognome, email, telefono, azienda (se indicata), descrizione del progetto, scadenza e budget indicativi, inviati tramite il modulo pubblico di richiesta</li>
          </ul>
        </Section>

        <Section title="3. Finalità e base giuridica del trattamento">
          <p>I dati vengono trattati per le seguenti finalità:</p>
          <ul className="list-disc list-inside space-y-1 mt-2 ml-2">
            <li><strong className="text-gray-300">Risposta alle richieste</strong> — ricontattarti dopo l'invio del modulo, valutare il progetto e formulare un preventivo (base: misure precontrattuali su tua richiesta, art. 6 par. 1 lett. b GDPR)</li>
            <li><strong className="text-gray-300">Erogazione del servizio</strong> — gestione dell'account, accesso alla piattaforma, collaborazione su progetti e file (base: esecuzione del contratto, art. 6 par. 1 lett. b GDPR)</li>
            <li><strong className="text-gray-300">Comunicazioni di servizio</strong> — notifiche relative all'account, conferma email, recupero password (base: esecuzione del contratto)</li>
            <li><strong className="text-gray-300">Sicurezza e prevenzione abusi</strong> — protezione della piattaforma da accessi non autorizzati (base: legittimo interesse, art. 6 par. 1 lett. f GDPR)</li>
            <li><strong className="text-gray-300">Adempimenti di legge</strong> — ove applicabile (base: obbligo legale, art. 6 par. 1 lett. c GDPR)</li>
          </ul>
        </Section>

        <Section title="4. Conservazione dei dati">
          <p>
            I dati vengono conservati per tutta la durata del rapporto contrattuale e per il periodo
            necessario ad adempiere agli obblighi di legge. In caso di richiesta di cancellazione
            dell'account, i dati vengono eliminati entro 30 giorni, salvo obblighi di legge che ne
            impongano la conservazione.
          </p>
        </Section>

        <Section title="5. Responsabili del trattamento (Sub-processor)">
          <p>Per erogare il servizio ci avvaliamo dei seguenti fornitori terzi, con i quali sono stati stipulati accordi conformi al GDPR:</p>
          <div className="mt-3 space-y-3">
            <div className="bg-gray-900 rounded-lg p-4">
              <p className="text-gray-300 font-medium">Supabase Inc.</p>
              <p className="text-xs text-gray-500 mt-1">Database, autenticazione e archiviazione. Server in area EU. DPA disponibile su supabase.com/dpa</p>
            </div>
            <div className="bg-gray-900 rounded-lg p-4">
              <p className="text-gray-300 font-medium">Cloudflare Inc.</p>
              <p className="text-xs text-gray-500 mt-1">Hosting della piattaforma (Cloudflare Pages) e archiviazione file (Cloudflare R2). Privacy Shield e Binding Corporate Rules attivi.</p>
            </div>
            <div className="bg-gray-900 rounded-lg p-4">
              <p className="text-gray-300 font-medium">Anthropic PBC</p>
              <p className="text-xs text-gray-500 mt-1">Elaborazione AI di testi per funzionalità assistite. I dati trasmessi non vengono usati per addestrare modelli.</p>
            </div>
            <div className="bg-gray-900 rounded-lg p-4">
              <p className="text-gray-300 font-medium">Brevo (Sendinblue SAS)</p>
              <p className="text-xs text-gray-500 mt-1">Invio dell'email con cui il team viene avvisato di una nuova richiesta dal sito. Società con sede in Francia, dati trattati nell'area UE.</p>
            </div>
          </div>
        </Section>

        <Section title="6. Trasferimento dati extra-UE">
          <p>
            Alcuni dei nostri fornitori (Supabase, Cloudflare, Anthropic) hanno sede negli Stati Uniti.
            I trasferimenti avvengono nel rispetto delle garanzie previste dal GDPR, mediante
            Clausole Contrattuali Standard (SCC) approvate dalla Commissione Europea.
          </p>
        </Section>

        <Section title="7. Cookie e tecnologie simili">
          <p>
            Questa piattaforma utilizza esclusivamente <strong className="text-gray-300">cookie tecnici strettamente necessari</strong> al
            funzionamento del servizio (gestione della sessione di autenticazione). Non vengono
            utilizzati cookie di profilazione, cookie di terze parti a scopo pubblicitario o
            strumenti di tracciamento comportamentale.
          </p>
          <p>
            Poiché vengono utilizzati solo cookie tecnici essenziali, non è richiesto il consenso
            ai sensi dell'art. 122 del Codice Privacy e delle Linee Guida del Garante.
          </p>
        </Section>

        <Section title="8. Diritti dell'interessato">
          <p>In qualità di interessato hai diritto di:</p>
          <ul className="list-disc list-inside space-y-1 mt-2 ml-2">
            <li><strong className="text-gray-300">Accesso</strong> — ottenere conferma che sia in corso un trattamento di dati che ti riguardano e riceverne copia</li>
            <li><strong className="text-gray-300">Rettifica</strong> — correggere dati inesatti o incompleti</li>
            <li><strong className="text-gray-300">Cancellazione</strong> ("diritto all'oblio") — richiedere la rimozione dei tuoi dati</li>
            <li><strong className="text-gray-300">Limitazione</strong> — richiedere la sospensione del trattamento in determinati casi</li>
            <li><strong className="text-gray-300">Portabilità</strong> — ricevere i tuoi dati in formato strutturato e leggibile da una macchina</li>
            <li><strong className="text-gray-300">Opposizione</strong> — opporti al trattamento basato su legittimo interesse</li>
          </ul>
          <p className="mt-3">
            Per esercitare i tuoi diritti scrivi a <a href="mailto:plutonicstudio.vfx@gmail.com" className="text-violet-400 hover:text-violet-300">plutonicstudio.vfx@gmail.com</a>.
            Hai inoltre il diritto di proporre reclamo al <strong className="text-gray-300">Garante per la protezione dei dati personali</strong> (www.garanteprivacy.it).
          </p>
        </Section>

        <Section title="9. Modifiche alla presente informativa">
          <p>
            Ci riserviamo il diritto di aggiornare questa Privacy Policy in qualsiasi momento.
            Le modifiche sostanziali saranno comunicate via email o tramite avviso in piattaforma.
            L'uso continuato del servizio dopo la notifica costituisce accettazione delle modifiche.
          </p>
        </Section>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-xs text-gray-600">
          <p>Plutonic Studio — Matteo Congedo P.IVA 05352990757</p>
          <p className="mt-1">
            <a href="mailto:plutonicstudio.vfx@gmail.com" className="hover:text-gray-400 transition-colors">plutonicstudio.vfx@gmail.com</a>
          </p>
        </div>

      </div>
    </div>
  )
}

export default PrivacyPolicy
